import React, { Component } from "react";

const defaultProps = {
  onChange:                   () => {},
  onKeyUp:                    () => {},
  onKeyDown:                  () => {},
  onKeyPress:                 () => {},
  onFocus:                    () => {},
  onClickButton:              () => {},
  name:                       'input',
  placeholder:                'Input value',
  refName:                    'input',
  label:                      '',
  tip:                        '',
  disabled:                   false,
  required:                   false,
  requiredSymbol:             false,
  pattern:                    undefined,
  actionInLabelText:          '',
  actionInLabelCallback:      () => {},
  addSpaceIfAdjacentHasError: false,
  dataTestId:                 '',
  step:                       null,
}

class SearchInput extends Component {
  constructor(props) {
    super(props)

    this.handleChange  = this.handleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleKeyUp   = this.handleKeyUp.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleFocus  = this.handleFocus.bind(this);
    this.handleClickButton = this.handleClickButton.bind(this);
  }

  handleChange(e) { this.props.onChange(e) }
  handleKeyDown(e) { this.props.onKeyDown(e) }
  handleKeyUp(e) { this.props.onKeyUp(e) }
  handleKeyPress(e) { this.props.onKeyPress(e) }
  handleFocus(e) { this.props.onFocus() }
  handleClickButton(e) { this.props.onClickButton() }

  render() {
    return (
      <div className="ds-formGroup left-and-right-inner-addon input-container">
        <i className="materialIcon left">search</i>
        <button
          className="right ds-btn -primary"
          id="search-button"
          onClick={event => this.handleClickButton(event)}
        >
          Search
        </button>
        <input
          data-test={this.props.name}
          name={this.props.name}
          type={this.props.type}
          value={this.props.value}
          id={this.props.id}
          onChange={this.handleChange}
          onKeyDown={this.handleKeyDown}
          onKeyUp={this.handleKeyUp}
          onKeyPress={this.handleKeyPress}
          placeholder={this.props.placeholder}
          disabled={this.props.disabled}
          required={this.props.required}
          max={this.props.max}
          min={this.props.min}
          step={this.props.step}
          maxLength={this.props.maxLength}
          minLength={this.props.minLength}
          pattern={this.props.pattern}
          onFocus={this.handleFocus}
          data-testid={this.props.dataTestId}
        />
      </div>
    );
  }
}

SearchInput.defaultProps = defaultProps;

export default SearchInput;



// WEBPACK FOOTER //
// ./src/features/shared/components/forms/SearchInput.js